"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PractitionerQualification = void 0;
/**
 * A person who is directly or indirectly involved in the provisioning of healthcare.
 */
var PractitionerQualification = /** @class */ (function () {
    function PractitionerQualification() {
    }
    return PractitionerQualification;
}());
exports.PractitionerQualification = PractitionerQualification;
